import { formatPhoneNumber } from "../components/utils/formatnumber";

export function getForwardNumberOptions(channels = []) {
  return channels
    .filter((item) => item.M?.type?.S === "forward_number")
    .map((item) => {
      const chId = item.M.ch_id?.S ?? item.ch_id ?? item.M.value?.S;
      const formattedNumber = formatPhoneNumber(item.M.value?.S ?? item.M.value ?? "");
      const label = item.M.label?.S ?? item.label ?? "";
      return { value: chId, label: label ? `${label} - ${formattedNumber}` : formattedNumber };
    });
}

export function resolveForwardNumberSelectValue(numberValue, channels = [], destinationOptions = []) {
  if (!numberValue) return numberValue ?? "";
  const hasMatch = destinationOptions.some((o) => o.value === numberValue);
  if (hasMatch) return numberValue;
  const byPhone = channels.find(
    (c) => c.M?.type?.S === "forward_number" && (c.M.value?.S ?? c.value) === numberValue
  );
  if (byPhone) return byPhone.M?.ch_id?.S ?? byPhone.ch_id ?? numberValue;
  return numberValue;
}

export function resolveForwardNumberPhone(value, channels = []) {
  if (!value) return "";
  const [channelId, phoneFromModal] = Array.isArray(value) ? value : [value, undefined];
  if (phoneFromModal != null) return phoneFromModal;
  const ch = channels.find((c) => (c.M?.ch_id?.S ?? c.ch_id) === channelId);
  return ch ? (ch.M?.value?.S ?? ch.value) : channelId;
}

export function getForwardNumberDisplayLabel(phone, channels = []) {
  if (!phone) return null;
  const channel = channels.find(
    (c) => c.M?.type?.S === "forward_number" && (c.M.value?.S ?? c.value) === phone
  );
  if (channel) {
    const formattedNumber = formatPhoneNumber(channel.M.value?.S ?? channel.M.value ?? "");
    const label = channel.M.label?.S ?? channel.label ?? "";
    return label ? `${label} - ${formattedNumber}` : formattedNumber;
  }
  return formatPhoneNumber(phone);
}

export function getDefaultForwardingNumberForUser(org, userId) {
  const userEntry = org?.users?.L?.find((u) => u?.M?.userId?.S === userId);
  const assigned = userEntry?.M?.forwarding_number?.S;
  if (assigned) return assigned;
  return (
    org?.channels?.L?.find((e) => e?.M?.type?.S === "forward_number")?.M?.value?.S ?? null
  );
}
